import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadCommands from './commands';
import loadBlocks from './blocks';
import loadPreBuiltLayoutBlocks from './preBuiltLayoutBlocks';
import { preBuiltSectionRef } from './consts';

export default grapesjs.plugins.add('gjs-pre-built-section', (editor, opts) => {
  let options = opts || {};
  const default_commands = {
    pre_built_section_custom_code: 'pre-built-section:open-modal',
  };

  const default_refs = {
    preBuiltSectionRef: preBuiltSectionRef,
    keyMarketPlaceCustomCode: preBuiltSectionRef + '__code',
  };

  const default_labels = {
    pre_built_section_custom_code: 'Pre-Built Layouts Custom Code',
    buttonLabel: `<i class="fa fa-plus"></i> Add Pre-Built Layout`,
  };

  const default_titles = {
    buttonTitle: 'Add selected section to a canvas',
  };

  const default_categories = [
    { label: 'All', value: 'ALL' },
    { label: 'Features', value: 'FEATURES' },
    { label: 'Footers', value: 'FOOTERS' },
    { label: 'Forms', value: 'FORMS' },
    { label: 'Headings', value: 'HEADINGS' },
    { label: 'Hero Section', value: 'HERO_SECTION' },
    { label: 'Intros', value: 'INTROS' },
    { label: 'Dashboard', value: 'DASHBOARD' },
    { label: 'Navigations', value: 'NAVIGATIONS' },
    { label: 'Pricing', value: 'PRICING' },
    { label: 'Services', value: 'SERVICES' },
    { label: 'Teams', value: 'TEAMS' },
    { label: 'Testimonials', value: 'TESTIMONIALS' },
    { label: 'Cards', value: 'CARDS' },
    { label: 'Others', value: 'OTHERS' },
  ];

  let defaults = {
    pfx: 'pre-built-section',
    blocks: [preBuiltSectionRef],
    defaultStyle: true,
    label: 'Pre-Built Layouts',
    category: 'Advanced',
    refs: default_refs,
    commands: default_commands,
    labels: default_labels,
    titles: default_titles,
    categories: default_categories,
    blockPreBuiltSectionCode: {},
    propsPreBuiltSectionCode: {},
    placeholderContent: `<span>Insert Pre-Built Layout Here</span>`,
    selectArrow: `<div class="gjs-d-s-arrow"></div>`,
    toolbarBtnPreBuiltSectionCode: {},
    placeholderScript: `<div style="pointer-events: none; padding: 10px;">
      <svg viewBox="0 0 24 24" style="height: 30px; vertical-align: middle;">
        <path d="M13 14h-2v-4h2m0 8h-2v-2h2M1 21h22L12 2 1 21z"></path>
        </svg>
      Pre-Built Layout with <i>&lt;script&gt;</i> can't be rendered on the canvas
    </div>`,
    modalTitle: 'Pre-Built Layouts',
    codeViewOptions: {},
    commandPreBuiltSectionCode: {},
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
  loadPreBuiltLayoutBlocks(editor, options);
  loadCommands(editor, options);
});
